import moment from "moment";
import "moment-timezone";

export const forwarderImporterColumns = [
  {
    accessorKey: "forwarder",
    header: "Forwarder",
    type: "string",
    size: 140,
  },
  {
    accessorKey: "importer",
    header: "Importer",
    type: "string",
    size: 140,
  },
];

export const columns = [
  {
    accessorKey: "actionButtons",
    header: "Action",
    size: 130,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
  {
    accessorKey: "containerNumber",
    header: "Container",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "vehicleNumber",
    header: "Vehicle",
    type: "string",
    size: 140,
  },
  {
    accessorKey: "vessel",
    header: "Vessel",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "containerGrossWeight",
    header: "Container Gross Weight",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "nlcSealNo",
    header: "NLC Seal Number",
    type: "string",
    size: 200,
  },
  { accessorKey: "driverName", header: "Driver", size: 130 },
  // {
  //   accessorKey: "vehicleType",
  //   header: "Type",
  //   type: "string",
  //   size: 120,
  // },
  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  {
    accessorKey: "consignmentType",
    header: "Consignment ",
    description: "This column has a value getter and is not sortable.",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "gdNumber",
    header: "GD#",
    size: 120,
    accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
  },
  {
    accessorKey: "virNumber",
    header: "VIR#",
    size: 120,
    accessorFn: (row: any) => ` ${row.virNumber || " "}`,
  },
  {
    accessorKey: "billNumber",
    header: "Bill#",
    size: 120,
    accessorFn: (row: any) => ` ${row.billNumber || " "}`,
  },
  {
    accessorKey: "isScanComplete",
    header: "Scan",
    size: 130,
    type: "boolean",
  },
  {
    accessorKey: "isWeightDone",
    header: "Weight",
    size: 140,
    type: "boolean",
  },
  {
    accessorKey: "isCommercialDone",
    header: "Commercial",
    size: 170,
    type: "boolean",
  },
  { accessorKey: "terminalLocation", header: "Location", size: 150 },
  {
    accessorKey: "cargoTypeName",
    header: "Cargo",
    size: 130,
    accessorFn: (row: any) => ` ${row.cargoTypeName || " "}`,
  },
  {
    accessorKey: "yardSlotInfo",
    header: "Yard",
    size: 130,
    accessorFn: (row: any) => ` ${row.yardSlotInfo || " "}`,
  },
  {
    accessorKey: "gateEntryDate",
    header: "Entry",
    size: 130,
    type: "dateTime",
    accessorFn: function customCell(row: any) {
      return `${
        row.gateEntryDate ? moment(row.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : ""
      }`;
    },
  },
  {
    accessorKey: "gateOutDate",
    header: "Checkout",
    size: 150,
    type: "dateTime",
    accessorFn: function customCell(row: any) {
      return `${row.gateOutDate ? moment(row.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
  {
    accessorKey: "isAnomlyDetected",
    header: "Anomaly",
    size: 150,
    type: "boolean",
  },
  {
    accessorKey: "vehicleInProgress",
    header: "In Progress ",
    size: 170,
    type: "boolean",
  },
];
